import React from 'react';
import { Link } from 'react-router-dom';
import './MeetAITeam.css';

function MeetAITeam() {
  return (
    <section className="text-center pb-5 mt-4 mt-md-5 pt-4 pt-md-5 position-relative bg-dark">
      <div className="container">
        <h2 className="h1 pt-1 mb-3 mb-md-4 text-light mt-4 mt-md-5 px-3 px-md-0">Your AI Quality Control Team</h2>
        <div className="row justify-content-center mb-3 mb-md-2 mb-lg-5">
          <div className="col-11 col-sm-10 col-md-8 col-lg-6">
            <p className="fs-lg text-light opacity-80 mb-lg-0 px-2 px-sm-0">
              Specialized agents embedded in every project, continuously auditing every submission against every data point in your project.
            </p>
          </div>
        </div>

        {/* Hero video */}
        <div className="position-relative zindex-5 mx-auto px-3 px-sm-4 px-md-0" style={{ maxWidth: '1100px', transform: 'translateZ(-100px)' }}>
          <div className="tilt-3d" data-tilt data-tilt-full-page-listening data-tilt-max="12" data-tilt-perspective="1000">
            <video
              src={`${process.env.PUBLIC_URL}/assets/home_page/v3/videos/compliance.mp4`}
              className="w-100 rounded-3 shadow-lg"
              autoPlay
              loop
              muted
              playsInline
              onError={(e) => {
                console.error('Video failed to load');
                e.target.style.display = 'none';
              }}
            />
          </div>
        </div>

        <div className="pt-md-3 pb-md-5 my-md-3 my-lg-4 px-3 px-md-0" style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <div className="qexplain">
            <h3>Total project quality control.</h3>
            <p>Orbix reviews every submission against the full context of your project: procedures, qualifications, examination reports, imagery, and every decision your team makes. The moment something falls outside spec, the technician is notified and told exactly how to fix it.</p>
            <Link className="qcta" to="/apps/prime">Meet the AI Quality Team <span>&rarr;</span></Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MeetAITeam;
